import Vue from "vue";
import store from "../store/index";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Register from "../views/Register.vue";
import Cookies from "js-cookie";
import { RouterTabRoutes } from 'vue-router-tab'
Vue.use(VueRouter);

const routes = [


  {
    path: '/Acounting',
    component: () => import('@/components/layout/mainAcounting.vue'),
    meta: { authOnly: true, role: true },
    ...RouterTabRoutes,
    children: [
      { path: '/Payroll', component: () => import('@/components/Accounting/Salary/New_Month.vue'), meta: { title: 'Home' } },
      { path: '/Store_Advance_payment', component: () => import('@/components/Accounting/AcountEmployees/Store_Advance_payment.vue') },
      { path: '/Add_balance', component: () => import('@/components/Accounting/Balance_Site/Add_balance_site.vue') },
      { path: '/Store_Advance_payment_Employees', component: () => import('@/components/Accounting/AcountEmployees/Store_Advance_payment_Employees.vue') },
      { path: '/Store_debet_payment_Employees', component: () => import('@/components/Accounting/AcountEmployees/Store_debet_payment_Employees.vue') },
      { path: '/Showdetails/:id', props: true, component: () => import('@/components/Accounting/Salary/Showdetails.vue') },
      { path: '/approve_salary', component: () => import('@/components/Accounting/Salary/approve_salary.vue') },
      { path: '/AccountTypes', component: () => import('@/components/Treasurise/AccountTypes/AccountTypes.vue') },
      { path: '/FinancialAccounts', component: () => import('@/components/Treasurise/FinancialAccounts/FinancialAccounts') },
      { path: '/FinancialSuppliers', component: () => import('@/components/Treasurise/FinancialAccounts/FinancialSupplier.vue') },
      { path: '/Collection', component: () => import('@/components/Treasurise/Collection.vue') },
      { path: '/Show_Merga_Salary', component: () => import('@/components/Accounting/Salary/Show_Merga_Salary.vue') },
      { path: '/advances-supplier-week', name: 'AdvanceSupplierWeek', component: () => import('@/components/Accounting/Weeks/BalanceWeeks.vue') },
      { path: '/weekly-settlements-archive', component: () => import('@/components/Accounting/Weeks/WeeklySettlementArchive.vue') },
      { path: '/BalanceWeeksToWeeks', component: () => import('@/components/Accounting/Weeks/BalanceWeeksToWeeks') },
      { path: '/Cl_Week_Suppler_cancel', component: () => import('@/components/Accounting/Weeks/WeeklySupplierStatement.vue') },
      { path: '/Cl_Week_Suppler_inSupply', component: () => import('@/components/Accounting/Weeks/WeeklySupplierStatementSupply.vue') },
      
      { path: '/AdvanceRequest', component: () => import('@/views/Employees/AdvanceRequest.vue') },
      {
        path: '/view_and_analyze_salary', component: () => import('@/components/Reports/vocabulary/view_and_analyze_salary.vue'),
        children: [
          { path: '/attendances', component: () => import('@/components/Reports/vocabulary/analyze/attendances.vue') },
          { path: '/emp_balances', component: () => import('@/components/Reports/vocabulary/analyze/emp_balances') },
          { path: '/emp_deductions', component: () => import('@/components/Reports/vocabulary/analyze/emp_deductions') },
          { path: '/emp_hours', component: () => import('@/components/Reports/vocabulary/analyze/emp_hours') },
          { path: '/emp_atten_all', component: () => import('@/components/Reports/vocabulary/analyze/AnalyzeDayAddend') },
          { path: '/emp_atten_Fri', component: () => import('@/components/Reports/vocabulary/analyze/AnalyzeDayFrid') },
          { path: '/AnalyzeAdvance', component: () => import('@/components/Reports/vocabulary/analyze/AnalyzeAdvance') },
          
        ]
      },
      //نظام المرتبات الجديد
      { path: '/SalarySettlementCenter', component: () => import('@/views/SalarySettlementCenter/SalarySettlementCenter.vue') },
      { path: '/salary-details/:id', props: true, name: 'SalaryDetails', component: () => import('@/views/SalarySettlementCenter/SalaryDetailsSheet.vue') },
      { path: '/individual-payslip/:id', props: true, name: 'IndividualPayslip', component: () => import('@/views/SalarySettlementCenter/IndividualPayslip.vue') },

    ]
  },
  {
    path: '/Suppliers',
    component: () => import('@/components/layout/mainSuppliers.vue'),
    meta: { authOnly: true, role: true },
    ...RouterTabRoutes,
    children: [

      { path: '/NewSuppliers', component: () => import('@/components/Accounting/Suppliers/newSuppliers.vue') },

      { path: '/EditSuppliers', component: () => import('@/components/Accounting/Suppliers/EditSuppliers.vue') },

      { path: '/StoreSuppliersType', component: () => import('@/components/Accounting/Suppliers/StoreSuppliresType.vue') },


    ]
  },

  {
    path: '/Operation',
    component: () => import('@/components/layout/mainOperation.vue'),
    meta: { authOnly: true, role: true },
    children: [
      { path: '/operation', component: () => import('@/components/operation/operation.vue') },
      { path: '/operation_clearance', component: () => import('@/components/operation/operation_clearance') },
      { path: '/ResultAdvanc', component: () => import('@/components/operation/ResultAdvanc') },
      { path: '/Report_clearance_Supplier', component: () => import('@/components/Reports/SupplierExcahnge/Supplier_Exchange_car.vue') },
      { path: '/Report_clearance_Supplier_is_services', component: () => import('@/components/Reports/SupplierExcahnge/Report_clearance_Supplier_is_services.vue') },
      { path: '/Report_clearance_Supplier_is_Supplier', component: () => import('@/components/Reports/SupplierExcahnge/Report_clearance_Supplier_is_Supplier.vue') },
      { path: '/Report_clearance_Supplier_is_supplier_work', component: () => import('@/components/Reports/SupplierExcahnge/Report_clearance_Supplier_is_supplier_work.vue') },
      { path: '/Report_clearance_Supplier_is_supplier_work_site', component: () => import('@/components/Reports/SupplierExcahnge/Report_clearance_Supplier_is_supplier_work_site.vue') },
      { path: '/review_data', component: () => import('@/components/Reports/SupplierExcahnge/Report_clearance_Supplier_is_site.vue') },
      { path: '/review_data_Now', component: () => import('@/components/Reports/SupplierExcahnge/Report_clearance_Supplier_is_siteNo.vue') },
      { path: '/review_data_Supplier_Now', component: () => import('@/components/Reports/SupplierExcahnge/Report_clearance_Supplier_is_site_supplier_Now.vue') },
      { path: '/review_data_Supplier_Now_G', component: () => import('@/components/Reports/SupplierExcahnge/review_data_Supplier_Now_G.vue') },

      { path: '/detailed_statement_Supplier', component: () => import('@/components/Reports/SupplierExcahnge/detailed_statement_Supplier.vue') },
      { path: '/Supplier_remainig', component: () => import('@/components/Reports/SupplierExcahnge/Supplier_remainig.vue') },
      { path: '/cashexchangeWithClearance', component: () => import('@/components/Treasurise/CashExchangeSupplierClearance.vue') },
      { path: '/KitTransfer', component: () => import('@/components/Kit/KitTransfer.vue') },
      { path: '/Report_Work', component: () => import('@/components/Reports/Operation/report_work.vue') },
      { path: '/Report_Work_supplier', component: () => import('@/components/Reports/Operation/Report_Work_supplier.vue') },
      { path: '/exchangeSolar', component: () => import('@/components/operation/exchangeSolar.vue') },
      { path: '/print_car', component: () => import('@/components/Supplier/Car/PrintCar.vue') },
      { path: '/print_Supplier', component: () => import('@/components/Supplier/Car/PrintSuppliers') },
      { path: '/Accepting_advances', component: () => import('@/components/Accounting/Suppliers/Accepting_advances.vue') },
      { path: '/Add_Advances_suppliers', component: () => import('@/components/Accounting/AcountEmployees/Add_Advances_suppliers.vue') },
      { path: '/StoreCar', component: () => import('@/components/Supplier/Car/StoreSupplierCar.vue') },
      { path: '/newOperation', component: () => import('@/components/Supplier/newOperation.vue') },
      { path: '/Modification_of_vehicle_data', component: () => import('@/components/Supplier/Car/ModificationOfVehicleData') },
      { path: '/UploadOperatingDocuments', component: () => import('@/components/operation/UploadOperatingDocuments') },
      
    
      { path: '/QuickWeeklyOperationMatrix', component: () => import('@/views/NewOpearation/QuickWeeklyOperationMatrix.vue') },
      { path: '/ContractorWeeklyReview', component: () => import('@/views/NewOpearation/ContractorWeeklyReview.vue') },
      { path: '/GetSiteDetailedReport', component: () => import('@/views/NewOpearation/Formal.vue') },
      { path: '/SupplierWeeklySettlement', component: () => import('@/views/NewOpearation/SupplierWeeklySettlement.vue') },
      { path: '/SupplierSettlementArchive', component: () => import('@/views/NewOpearation/SupplierSettlementArchive.vue') },
      { path: '/ReportSolar', component: () => import('@/views/NewOpearation/ReportSolar.vue') },
      { path: '/HoursAnalytics', component: () => import('@/views/NewOpearation/HoursAnalytics.vue') },
      { path: '/review_data_Hours', component: () => import('@/views/NewOpearation/review_data_Supplier_Now_G.vue') },
      { path: '/ContractorGlobalStatement', component: () => import('@/views/NewOpearation/ContractorGlobalStatement') },
      { path: '/ContractorControlCenter', component: () => import('@/views/Supplires/ContractorControlCenter.vue') },
      { path: '/OperationsPerformancePanorama', component: () => import('@/views/NewOpearation/OperationsPerformancePanorama') },
      
      { path: '/EditUsers', component: () => import('@/views/User/User.vue') },



    ]
  },
  {
    path: '/SearchEmployees',
    component: () => import('@/components/layout/mainEmployees.vue'),
    meta: { authOnly: true },
    name: 'Employees',
    children: [
      { path: '/CreateEmployee', name: 'Create_Employee', component: () => import(/* webpackChunkName: "CreateEmployee" */'@/components/Employees/NewEmp.vue') },
      { path: '/Employees', component: () => import('@/components/Employees/empInComAll.vue') },
      { path: '/SearchEmployees', component: () => import('@/views/Employees/empInComAll.vue') },
      { path: '/EmployeeRehire', component: () => import('@/components/Employees/EmployeeRehire.vue') },
      // { path: '/Employees_Site',name:'Employees', component: () => import('@/components/Employees/index.vue') },

      // { path: '/Show_Edit_Employee/:id', props: true, component: () => import('@/components/Employees/EditEmployee.vue') },
      { path: '/Show_Profile_Employee/:id', props: true, component: () => import('@/components/Employees/EmpProfile.vue') },
      { path: '/UpLoad_Images/:id', props: true, component: () => import('@/components/Employees/upload_img.vue') },
      
      { path: '/Attendance', component: () => import('@/components/Attendance/AttendanceDay.vue') },
      { path: '/NewAttendance', component: () => import('@/views/Employees/AttendanceDay.vue') },
      { path: '/NewEmpLeave', component: () => import('@/views/Employees/EmpLeave.vue') },
      
      
      { path: '/DayOfMonth', component: () => import('@/components/Attendance/DayOfMonth.vue') },
      { path: '/Add_hours', component: () => import('@/components/UserSite/hours/Add_hours.vue') },
      { path: '/Review_Attend', component: () => import('@/components/Attendance/Review_Attend.vue') },
      { path: '/ShowdetailsAttend', props: true, query: { id: 123, category: 'electronics' }, component: () => import('@/components/Attendance/ShowdetailsAttend.vue') },
      { path: '/Transfer', component: () => import('@/components/Employees/Transfer.vue') },
      { path: '/cancel', component: () => import('@/components/Employees/cancel.vue') },
      
      { path: '/CustomAttendanceEmployees', component: () => import('@/components/Attendance/CustomAttendanceEmployees.vue') },
      { path: '/CustomHoursEmployees', component: () => import('@/components/Attendance/CustomHoursEmployees.vue') },
      { path: '/CustomFridayEmployees', component: () => import('@/components/Attendance/CustomFridayEmployees.vue') },
      { path: '/CustomAdvanceEmployees', component: () => import('@/components/Accounting/AcountEmployees/Custom_Store_Advance_payment_Employees.vue') },
      { path: '/requestLeave', component: () => import('@/components/Accounting/AcountEmployees/RequestLeave.vue') },
      { path: '/Deduction', component: () => import('@/components/UserSite/discount/DeductionEmployees.vue') },
      { path: '/CreateMotive', component: () => import('@/components/Employees/CreateEmployeeMotive.vue') },
      { path: '/Store_Deduction_Emp/:id', props: true, component: () => import('@/components/UserSite/discount/Store_Deduction_Emp.vue') },
      { path: '/test_1', props: true, component: () => import('@/components/Employees/test.vue') },
      { path: '/test_2', props: true, component: () => import('@/components/Employees/testSalaryCarJop.vue') },
      
      /** بداية النظام المطور */
      { path: '/EmployeeAdvancesSystem', component: () => import('@/views/Employees/EmployeeAdvancesSystem.vue') },
      { path: '/ActiveNewEmployee', component: () => import('@/views/Employees/ActiveNewEmployee.vue') },
      { path: '/bulkTransferEmployee', component: () => import('@/views/Employees/bulkTransferEmployee.vue') },
      { path: '/RequestRehire', component: () => import('@/views/Employees/RequestRehire.vue') },
      { path: '/EmployeeTermination', component: () => import('@/views/Employees/EmployeeTermination.vue') },
      { path: '/EmployeeAdjustment', component: () => import('@/views/Employees/EmployeeAdjustment.vue') },
      { path: '/OperationsArchive', component: () => import('@/views/Employees/OperationsArchive.vue') },
      { path: '/Show_Edit_Employee/:id', props: true, component: () => import('@/views/Employees/EditEmployees.vue') },
      { path: '/Employee_Service_Record/:id?', name:'Employee_Service_Record', props: true, component: () => import('@/views/Employees/EmployeeServiceRecord.vue') },
      { path: '/AdminReversalCenter', component: () => import('@/views/Employees/AdminReversalCenter.vue') },
      { path: '/JobCategoryReport', component: () => import('@/views/Employees/JobCategoryReport.vue') },
      { path: '/DataCompletionCheck', component: () => import('@/views/Employees/DataCompletionCheck.vue') },
        { path: '/EmployeeEvaluation', component: () => import('@/views/Employees/EmployeeEvaluation.vue') },
        { path: '/EvaluationReport', component: () => import('@/views/Employees/EmployeeEvaluation/EvaluationReport.vue') },
        { path: '/EidDeductionManager', component: () => import('@/views/Employees/EidDeductionManager.vue') },
        { path: '/BulkSalaryEditor', component: () => import('@/views/Employees/BulkSalaryEditor.vue') },
    ]
  },
  // {
  //   path: '/Attendance',
  //   component: () => import('@/components/layout/mainAttendance.vue'),
  //   meta: { authOnly: true },
  //   children: [

  //     { path: '/indexAttendance', component: () => import('@/components/Attendance/index.vue') },


  //   ]
  // },
  {
    path: '/UserSite',
    component: () => import('@/components/layout/mainUserSite.vue'),
    meta: { authOnly: true },
    children: [
      { path: '/ShowOrder', component: () => import('@/components/UserSite/UserAcounting/ShowOrder.vue') },
      { path: '/Advance_payment', component: () => import('@/components/UserSite/UserAcounting/Advance_payment.vue') },
      { path: '/MoveUnapproveSalary', component: () => import('@/components/Treasurise/MoveUnapproveSalary.vue') },
      { path: '/OilChangeFollowUpCheckSite', component: () => import('@/components/Garage/oil/OilChangeFollowUpCheckSite.vue') },
      { path: '/OperationsList/:id', props: true, component: () => import('@/components/Garage/oil/OperationsListCar') },
      { path: '/MayazOrder', component: () => import('@/components/Garage/mayaz/MayazOrder.vue') },
      { path: '/SiteMessOrder', component: () => import('@/components/Garage/mayaz/SiteMessOrder.vue') },
      { path: '/InventoryItemsManager', component: () => import('@/components/Garage/mayaz/InventoryItemsManager.vue') },
      { path: '/CentralMessDashboard', component: () => import('@/components/Garage/mayaz/CentralMessDashboard.vue') },
      { path: '/CentralWarehouseManager', component: () => import('@/components/Garage/mayaz/CentralWarehouseManager.vue') },


    ]
  },
  {
    path: '/Reports',
    component: () => import('@/components/layout/mainReports.vue'),
    meta: { authOnly: true },
    children: [
      { path: '/vocabulary_site', component: () => import('@/components/Reports/vocabulary/vocabulary_site.vue') },
      { path: '/vocabulary_emp', component: () => import('@/components/Reports/vocabulary/vocabulary_emp.vue') },
      { path: '/vocabulary_bill', component: () => import('@/components/Reports/vocabulary/vocabulary_bill.vue') },
      { path: '/Report_merge_monthly', component: () => import('@/components/Reports/vocabulary/Report_merge_monthly.vue') },
      { path: '/Report_monthly', component: () => import('@/components/Reports/vocabulary/Report_monthly.vue') },
      { path: '/Report_abs', component: () => import('@/components/Reports/Attendances/report_abs.vue') },
      { path: '/Report_Day', component: () => import('@/components/Reports/ReportDay/ReportDays.vue') },

    ]
  },
  {
    path: '/Maint',
    component: () => import('@/components/layout/mainMaintSite.vue'),
    meta: { authOnly: true },
    children: [
      { path: '/CreateRequest', component: () => import('@/components/Garage/Maintenance/CreateRequestMainte.vue') },
      { path: '/TimeLineMaintByCarId/:car_id', props: true, component: () => import('@/components/Garage/Maintenance/TimeLineMainte.vue') },
      { path: '/timeLineMaintByid/:id/:car_id', props: true, component: () => import('@/components/Garage/Maintenance/TimeLineMainte.vue') },
      { path: '/FollowRequest', component: () => import('@/components/Garage/Maintenance/FollowAllMainte.vue') },
      { path: '/Maintenance_log', component: () => import('@/components/Garage/Maintenance/MaintenanceLog.vue') },
      { path: '/Expenses_Report', component: () => import('@/components/Garage/Maintenance/Expenses/ExpensesReport.vue') },
      { path: '/Buy', component: () => import('@/components/Garage/inventory/Buy.vue') },
      // { path: '/OrderDetails/:id', props: true, component: () => import('@/components/Garage/inventory/OrderDetails.vue') },

    ]
  },
  {
    path: '/Garage',
    component: () => import('@/components/layout/mainGarage.vue'),
    meta: { authOnly: true, role: true },
    children: [
      {
        path: '/SettingsCar', component: () => import('@/components/Garage/oil/SettingsOilCar.vue'),

        children: [
          { path: '/ChangeOilTypeCar', component: () => import('@/components/Garage/oil/settingOilTypeCar.vue'), }
        ]
      },

      { path: '/ReleaseOrder', component: () => import('@/components/Garage/inventory/ReleaseOrder.vue') },
      { path: '/NewItemCard', component: () => import('@/components/Garage/inventory/ItemCard/NewItemCard.vue') },
      { path: '/ShowItemCard', component: () => import('@/components/Garage/inventory/ItemCard/ShowItemCard.vue') },
      { path: '/OilChangeFollowUpCheckGarag', component: () => import('@/components/Garage/oil/OilChangeFollowUpCheckGarag.vue') },
      { path: '/Oil_change_record', component: () => import('@/components/Garage/oil/OilChangeRecord.vue') },
      { path: '/ReportChangeOilWekly', component: () => import('@/components/Garage/oil/ReportChangeOilWekly.vue') },

      { path: '/OilAdvanceSite', component: () => import('@/components/Garage/oil/OilAdvanceSite.vue') },
      { path: '/PrintOilAdvanceSite', component: () => import('@/components/Garage/oil/PrintOilAdvanceSite.vue') },
      { path: '/OperationsList_G/:id', props: true, component: () => import('@/components/Garage/oil/OperationsListCar') },

      { path: '/ViewOrderDetails/:id', props: true, component: () => import('@/components/Garage/mayaz/OrderDetails.vue') },

      { path: '/PriceControl', component: () => import('@/components/Garage/mayaz/priceControl.vue') },
      { path: '/SiteOrder', component: () => import('@/components/Garage/mayaz/SiteOrder.vue') },

      { path: '/PrintPurchaseInformation', component: () => import('@/components/Garage/mayaz/PrintPurchaseInformation.vue') },
    ]
  },
  {
    path: '/moveUnapprove',
    component: () => import('@/components/layout/mainTreasuries.vue'),

    children: [
      { path: '/SiteBalance', component: () => import('@/components/Treasurise/Showtreasuries.vue') },
      { path: '/ReturnValue', component: () => import('@/components/Treasurise/Balance/ReturnValue.vue') },
      { path: '/CombinedCharge', component: () => import('@/components/Treasurise/Balance/CombinedCharge.vue') },
      { path: '/Treasuries', component: () => import('@/components/Treasurise/cashexchange.vue') },
      { path: '/moveUnapprove', component: () => import('@/components/Treasurise/MoveUnapprove.vue') },
      { path: '/moveUnapproveBalance', component: () => import('@/components/Treasurise/Balance/moveUnapproveBalance.vue') },
      { path: '/CustodyRecord', component: () => import('@/components/Treasurise/CustodyRecord.vue') },
      { path: '/CustodyRecordAccount', component: () => import('@/components/Treasurise/Update/CustodyRecord.vue') },
      { path: '/CustodyRecordAccountDetails', component: () => import('@/components/Treasurise/Update/CustodyRecordWithDetails.vue') },
      { path: '/CustodyForSite', component: () => import('@/components/Treasurise/CustodyForSite.vue') },
      { path: '/CustodyAllSite/:id', props: true, component: () => import('@/components/Treasurise/CustodyAllSite.vue') },
      { path: '/NewAccounts', component: () => import('@/components/Treasurise/NewAccounts/NewAccounts.vue') },

      { path: '/AccountSettings', component: () => import('@/components/Treasurise/Settings/AccountSettings.vue') },
      { path: '/CustomerAccountStatement/:id', props: true, component: () => import('@/components/Treasurise/CustomerAccountStatement') },
      { path: '/CustomerAccountWeeklyStatement/:id?', props: true, component: () => import('@/components/Treasurise/Report/WeeklyAccountStatement.vue') },
      { path: '/CustomerAccountOneWeeklyStatement', component: () => import('@/components/Treasurise/Report/OneWeeklyAccountStatement.vue') },
      { path: '/External_Custody_Statement', component: () => import('@/components/Treasurise/ExternalCustodyStatement') },
      { path: '/BeforeWeeklyStatement', component: () => import('@/components/Treasurise/Report/BeforeWeeklyStatement.vue') },
      { path: '/Payment', component: () => import('@/components/Treasurise/Payments/Payment.vue') },
      { path: '/Discount', component: () => import('@/components/Treasurise/Payments/Discount.vue') },
      // { path: '/PaymentMore', component: () => import('@/components/Treasurise/Payments/PaymentMore.vue') },
      { path: '/ReturnAmount', component: () => import('@/components/Treasurise/Payments/Return_value.vue') },
      { path: '/BalanceSite', component: () => import('@/components/Treasurise/Payments/AddBalanceSite') },
      { path: '/NewOrder', component: () => import('@/components/Treasurise/Order/NewOrder.vue') },
      { path: '/NewOrderOut', component: () => import('@/components/Treasurise/Order/NewOrderOut.vue') },
      { path: '/MaintenanceExpenses', component: () => import('@/components/Treasurise/MaintenanceExpenses/MaintenanceExpenses.vue') },
     



      // بداية العمل على بند الخزنة الجديد



    ]
  },

  {
    path: '/Warehouse_Management',
    component: () => import('@/components/layout/mainCustody.vue'),

    children: [
      { path: '/index', component: () => import('@/components/inventory/index.vue') },
      { path: '/UploadFile', component: () => import('@/components/Documents/FileUpload') },
      { path: '/WarehouseStockControl', component: () => import('@/views/WarehouseStock/WarehouseStockControl.vue') },
      { path: '/ManageInventoryItems', component: () => import('@/views/WarehouseStock/ManageInventoryItems.vue') },
      { path: '/InternalTransferVoucher', component: () => import('@/views/WarehouseStock/InternalTransferVoucher.vue') },
      { path: '/InternalTransferArchive', component: () => import('@/views/WarehouseStock/InternalTransferArchive.vue') },
      { path: '/EquipmentConsumptionReport', component: () => import('@/views/WarehouseStock/EquipmentConsumptionReport.vue') },
      { path: '/InventoryValuationReport', component: () => import('@/views/WarehouseStock/InventoryValuationReport.vue') },
      { path: '/ExternalOverhaulVoucher', component: () => import('@/views/WarehouseStock/ExternalOverhaulVoucher.vue') },
      { path: '/EquipmentHistoryLog', component: () => import('@/views/WarehouseStock/EquipmentHistoryLog.vue') },
      { path: '/EquipmentPartsReport', component: () => import('@/views/WarehouseStock/EquipmentPartsReport.vue') },
      { path: '/InboundInventory', component: () => import('@/views/WarehouseStock/InboundInventory.vue') },
      { path: '/InboundArchive', component: () => import('@/views/WarehouseStock/InboundArchive.vue') },
      { path: '/InternalTransfer', component: () => import('@/views/WarehouseStock/InternalTransfer.vue') },
      { path: '/TransferArchive', component: () => import('@/views/WarehouseStock/TransferArchive.vue') },
    
      { path: '/WarehouseValuationReport', component: () => import('@/views/WarehouseStock/WarehouseValuationReport.vue') },
      { path: '/DelegateInboundPurchase', component: () => import('@/views/WarehouseStock/DelegateInboundPurchase.vue') },
      { path: '/ManagementMaintenanceCosting', component: () => import('@/views/WarehouseStock/ManagementMaintenanceCosting.vue') },
      { path: '/FieldMaintenanceTicket', component: () => import('@/views/WarehouseStock/FieldMaintenanceTicket.vue') },
      
  



      { path: '/CustomReportBuilder', component: () => import('@/views/Report/CustomReportBuilder.vue') },
    

    ]
  },
  {
    path: '/OnlineNotifications',
    component: () => import('@/components/layout/MainOnLineNotifications.vue'),

  },

  {
    path: '/Rating',
    component: () => import('@/components/layout/mainRating.vue'),

    children: [
      { path: '/Rating', component: () => import('@/components/Employees/Rating/index.vue') },
      { path: '/ShowRating', component: () => import('@/components/Employees/Rating/ShowRatingOfEmployees.vue') },
      { path: '/ProfileRating', component: () => import('@/components/Employees/Rating/ProfileRating.vue') },

    ]
  },


  {
    path: '/Supply',
    component: () => import('@/components/layout/mainSupply.vue'),
    name: 'Supply',
    meta: { authOnly: true },

    children: [
      { path: '/Supply', component: () => import('@/components/Supply/SupplyWithSite.vue') },
      { path: '/supply_clearance', component: () => import('@/components/Supply/supply_clearance.vue') },
      { path: '/Review_and_receive', component: () => import('@/components/Supply/Review_and_receive.vue') },
      { path: '/Request_pricing/:id', props: true, component: () => import('@/components/Supply/Request_pricing.vue') },
      { path: '/Print_Review_and_receive', component: () => import('@/components/Supply/Print_Review_and_receive.vue') },
      { path: '/Report_clearance_Supply', component: () => import('@/components/Supply/Report_clearance_Supply.vue') },
      { path: '/Add_Advances_supply', component: () => import('@/components/Supply/Add_Advances_supply.vue') },
      { path: '/Report_clearance_Crusher', component: () => import('@/components/Supply/Report_clearance_Crusher.vue') },
      { path: '/Print_Review_and_receive_count', component: () => import('@/components/Supply/Print_Review_and_receive_count.vue') },
      { path: '/Limit_supply_quantities', component: () => import('@/components/Supply/Limit_supply_quantities.vue') },
      { path: '/UploadSupplyDocuments', component: () => import('@/components/Supply/UploadSupplyDocuments') },
      { path: '/ResultSupplyAdvanc', component: () => import('@/components/Supply/ResultSupplyAdvanc') },
      { path: '/ReportSupplyWithGroupBy', component: () => import('@/components/Supply/ReportSupplyWithGroupBy') },




    ]
  },
  {
    path: '/Settings',
    component: () => import('@/components/layout/mainSettings.vue'),

    children: [
      { path: '/NewSite', component: () => import('@/components/Settings/newSite.vue') },
      { path: '/ShowSite', component: () => import('@/components/Settings/ShowSite.vue') },
      { path: '/SuppliersType', component: () => import('@/components/Accounting/Suppliers/showSuppliersType.vue') },
      { path: '/Mov_type', component: () => import('@/components/Settings/MoveType/MoveType') },
      { path: '/GetUnit', component: () => import('@/components/Settings/Unit/Unit.vue') },
      { path: '/Price_kilo', component: () => import('@/components/Settings/Site/Price_kilo') },
      { path: '/Salary_Month', component: () => import('@/components/Settings/employees/Salary_Month') },
      { path: '/uplift', component: () => import('@/components/Employees/uplift.vue') },
      { path: '/ShowUser', component: () => import('@/components/Settings/User/ShowUser') },
    ]
  },
  {
    path: '/SiteExpense',
    component: () => import('@/components/layout/mainExpenses.vue'),

    children: [
      { path: '/SiteExpense', component: () => import('@/views/VaultManagement/SiteExpense.vue') },
            { path: '/VaultManagement', component: () => import('@/views/VaultManagement/VaultManagement.vue') },
      { path: '/ExpenseOperationLog', component: () => import('@/views/VaultManagement/ExpenseOperationLog.vue') },
      { path: '/VaultApprove', component: () => import('@/views/VaultManagement/VaultApprove.vue') },
      { path: '/SiteFunding', component: () => import('@/views/VaultManagement/SiteFunding.vue') },
      { path: '/ExpenseApproval', component: () => import('@/views/VaultManagement/ExpenseApproval.vue') },
      { path: '/ExpenseReport', component: () => import('@/views/VaultManagement/ExpenseReport.vue') },
      { path: '/SiteDebts', component: () => import('@/views/VaultManagement/SiteDebts.vue') },
      { path: '/DelegateWallets', component: () => import('@/views/VaultManagement/DelegateWallets.vue') },
      { path: '/FinancialAdjustments', component: () => import('@/views/VaultManagement/FinancialAdjustments.vue') },
      { path: '/SiteTransfer', component: () => import('@/views/VaultManagement/SiteTransfer.vue') },
      { path: '/RecordEquipmentExpense', component: () => import('@/views/VaultManagement/RecordEquipmentExpense.vue') },
      { path: '/DelegateSettlement', component: () => import('@/views/VaultManagement/DelegateSettlement.vue') },
      { path: '/SitePendingMonitor', component: () => import('@/views/VaultManagement/SitePendingMonitor.vue') },
      { path: '/SiteManagerApprovalMonitor', component: () => import('@/views/VaultManagement/SiteManagerApprovalMonitor.vue') },
        { path: '/UnifiedMaintenanceTerminal', name: 'MaintenanceTerminal', component: () => import('@/views/WarehouseStock/UnifiedMaintenanceTerminal.vue') },
        { path: '/PendingMaintenanceCards', component: () => import('@/views/WarehouseStock/PendingMaintenanceCards.vue') },
           { path: '/EquipmentMaintenanceHistory', component: () => import('@/views/WarehouseStock/EquipmentMaintenanceHistory.vue') },
      // { path: '/Message', component: () => import('@/components/Message/index.vue') },
      // { path: '/CreateMessage', component: () => import('@/components/Message/CreateMessage.vue') },

    ]
  },
  {
    path: '/NOTIFICATIONS',
    component: () => import('@/components/layout/mainNotifications.vue'),

    children: [
      { path: '/Noti_Emp_Cancel', component: () => import('@/components/Employees/Noti_Emp_Cancel.vue') },
      { path: '/Noti_Emp_Transfer', component: () => import('@/components/Employees/Noti_Emp_Transfer.vue') },
      { path: '/Noti_Emp_New', component: () => import('@/components/Employees/Noti_Emp_New.vue') },
      { path: '/UnapproveEmpBalanceAdvance', component: () => import('@/components/UserSite/UserAcounting/UnapproveEmpBalanceAdvance.vue') },
      { path: '/NotifNewCar', component: () => import('@/components/Supplier/Car/NotifNewCar.vue') },

      { path: '/ConfirmationCodeDelete', component: () => import('@/components/Notification/ConfirmationCodeDelete.vue') }
    ]
  },
  {
    path: '/Ticket',
    component: () => import('@/components/layout/mainTicket.vue'),

    children: [
      { path: '/OpenTicket', component: () => import('@/components/Ticket/OpenTicket.vue') },
    ]
  },
  {
    path: '/PrintPage',
    component: () => import('@/components/layout/mainPrint.vue'),

    children: [
      { path: '/PrintPage', component: () => import('@/components/Print/PrintPage') },
      { path: '/MyCheques', component: () => import('@/components/Treasurise/Cheque/Cheques.vue') },
      { path: '/Follow', component: () => import('@/components/Treasurise/Cheque/Follow.vue') },
      { path: '/printCheque/:id?', props: true, component: () => import('@/components/Treasurise/Cheque/printCheque.vue') },
      { path: '/PdfLibrary', component: () => import('@/views/PdfLibrary/PdfLibrary.vue') },
      { path: '/UpLoadFilePdfLibrary', component: () => import('@/views/PdfLibrary/UpLoadFile.vue') },
    ]
  },
  {
    path: "/",
    name: "Home",

    component: () => import('@/views/Home.vue'),
    meta: { authOnly: true, role: true }
  },
  {
    path: '/Login',
    component: () => import('@/views/Login.vue'),
    meta: { guestOnly: true, role: true }
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: { guestOnly: true, role: true }
  },

  {
    path: '*',
    component: () => import('@/views/Error404.vue')
  },
  {
    path: '/404',
    component: () => import('@/views/Error404.vue')
  },
  {
    path: '/resultError',
    component: () => import('@/views/Error404Result.vue')
  }


];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
  store,
  mode: 'history',
  linkActiveClass: "active",
  linkExactActiveClass: "exact-active"
});

function isLoggedIn() {
  return localStorage.getItem("token");


}
// function isUser() {
//  return JSON.parse(localStorage.getItem("user"));


// }
// function tokenget() {
//   // return Cookies.get('XSRF-TOKEN')
//   console.log(Cookies.get('XSRF-TOKEN'));
//   // Cookies.remove('XSRF-TOKEN')
// }

router.beforeEach((to, from, next) => {

  // const admin = isUser().admin
  // const role = to.meta.role
  // const name = to.name
  // console.log(admin);
  if (to.matched.some(record => record.meta.authOnly)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!isLoggedIn()) {


      next({
        path: "/login"
        // query: { redirect: to.fullPath },lo
      });
      // } else if(!role) {

      //   // alert('lkjlkjlkjlkjlkj')
      //   next({
      //     path: "/404"
      //     // query: { redirect: to.fullPath },lo
      //   });


    } else {
      next();

    }
  } else if (to.matched.some(record => record.meta.guestOnly)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (isLoggedIn()) {
      next({
        path: "/",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }




  // if (to.matched.some(record => record.path  )) {

  //   if (isUser()) {
  //     const admin = isUser().role
  //     // console.log(to.path);
  //         if (JSON.parse(admin).some(item => item.name == to.path)) {
  //         //  console.log(item.name);
  //         next();
  //         }else{
  //           next({
  //             path: "/404"

  //           });

  //         }
  //   }else{
  //     next();
  //   }
  // }else{
  //   // next({
  //   //   path: "/404"

  //   // });
  // }
});



export default router;
